import { Validators } from 'core/services/Validators';
import { makeObservable } from 'mobx';
import { FormControl, FormGroup } from 'shared/libs/form';
import { ApplyJobStore } from '../ApplyJob.store';
import { SearchCityStore } from '../step_1-user-info/SearchCityStore';

export class WithoutResumeStore {
   public readonly searchCityStore: SearchCityStore;

   readonly form = new FormGroup({
      birthday: new FormControl<string>('', [Validators.required]),
      city_id: new FormControl<string | number>('', [Validators.required]),
   });

   constructor(private readonly applyJobStore: ApplyJobStore) {
      makeObservable(this, {});
      this.searchCityStore = new SearchCityStore();
   }
}
